const COUNT_IN_INTERVAL = 15; // x times
const INTERVAL_MS = 1000 * 40;

let throttled = false;
let prevId = '';
let remaining = COUNT_IN_INTERVAL;
let resentNotifyTime = Date.now();

export const resetInterval = (devOverrideDateNow?: number) => {
  resentNotifyTime = devOverrideDateNow || Date.now();
  remaining = COUNT_IN_INTERVAL;
};

/**
 * Continuously check for events and only reenable once activity lowers.
 *
 * Once throttle is active, it needs one full interval to clear it out again.
 */
export function recordEventAndThrottle(
  id: string,
  /** Simplify unit testing */
  devOverrideDateNow?: number
): 'allowed' | 'notify' | 'ignored' {
  if (id === prevId) {
    // Double safety to not even call notify function (which extra checks for unique displayed)
    return 'ignored';
  }
  prevId = id;
  // console.log({ throttled, remaining, resentNotifyTime });

  const passedWindow =
    (devOverrideDateNow || Date.now()) - resentNotifyTime > INTERVAL_MS;
  if (passedWindow) {
    if (remaining > 0) {
      throttled = false;
    }
    resetInterval(devOverrideDateNow);
    return throttled ? 'ignored' : 'allowed';
  }
  if (throttled) {
    // Reduce remaining, so we know if activity was reduced
    remaining -= 1;
    return 'ignored';
  }
  if (remaining <= 1) {
    throttled = true;
    resetInterval(devOverrideDateNow);
    return 'notify';
  }
  remaining -= 1;
  return 'allowed';
}
